module.exports = __webpack_public_path__ + "static/media/16-7.c5b75110.mp3";